// Note: These wrapper ES modules are necessary to make esbuild prune any
// unused exports/imports. As the same does not seem to apply in case of
// direct import from the commonjs modules, which is the format that most
// of the polyfills are packaged with.
export { Buffer } from './modules/browser-buffer';
export { process } from './modules/browser-process';